import { useState } from 'react';

import addDays from 'date-fns/addDays';
import addMonths from 'date-fns/addMonths';
import addWeeks from 'date-fns/addWeeks';
import subDays from 'date-fns/subDays';
import subMonths from 'date-fns/subMonths';
import subWeeks from 'date-fns/subWeeks';

export const useDateSwitch = (range: string) => {
	const [date, setDate] = useState(new Date());

	const reset = () => setDate(new Date());

	const add = () => {
		switch (range) {
			case 'day':
				return setDate(addDays(date, 1));
			case 'week':
				return setDate(addWeeks(date, 1));
			case 'month':
				return setDate(addMonths(date, 1));
			default:
				break;
		}
	};

	const subtract = () => {
		switch (range) {
			case 'day':
				return setDate(subDays(date, 1));
			case 'week':
				return setDate(subWeeks(date, 1));
			case 'month':
				return setDate(subMonths(date, 1));
			default:
				break;
		}
	};

	const selectDate = (date: Date) => setDate(date);

	return {
		date,
		reset,
		add,
		subtract,
		selectDate,
	};
};
